import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { StrategiesService } from '../../../../providers/strategies/strategies.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { find } from 'lodash';
import { IndicatorParamsFormData, InputParameter } from '@shared/providers';
import { IndicatorDisplayType } from '../../strategy.enums';
import { MIN_ABSOLUTE_VALUE } from '@app/_helpers/constants';

@Component({
  selector: 'app-strategy-params-form',
  templateUrl: './strategy-params-form.component.html',
  styleUrls: ['./strategy-params-form.component.scss']
})
export class StrategyParamsFormComponent implements OnInit {
  IndicatorDisplayType = IndicatorDisplayType;

  params: InputParameter[] = [];
  paramsForm: UntypedFormGroup;
  MIN_ABSOLUTE_VALUE = MIN_ABSOLUTE_VALUE;

  constructor(
    @Inject(MAT_DIALOG_DATA) public indicator: IndicatorParamsFormData,
    private strategyService: StrategiesService,
    private dialogRef: MatDialogRef<StrategyParamsFormComponent>
  ) { }

  ngOnInit(): void {
    const indicatorObject = find(this.strategyService.params, (params) => params.name === this.indicator.name);
    this.params = indicatorObject.inputParamterObjects;
    const groups = {};
    this.params.forEach(ind => {
      const validators = [];
      if (!ind.isOptional) {
        validators.push(Validators.required);
      } 
      if (ind.isOptional && ind.min_value && ind.max_value && (ind.displayType === IndicatorDisplayType.FLOAT || ind.displayType === IndicatorDisplayType.INTEGER)) {
        validators.push(Validators.min(ind.min_value));
        validators.push(Validators.max(ind.max_value));
      }
      // Add min validation for numeric fields
      if (!ind.isSelect) {
        validators.push(Validators.min(MIN_ABSOLUTE_VALUE));
      }
      groups[ind.name] = new UntypedFormControl(
        this.indicator.indicatorData ? this.indicator.indicatorData[ind.name] : ind.defaultValue, 
        validators
      );
    });
    this.paramsForm = new UntypedFormGroup(groups);
  }

  saveDialog() {
    if (this.paramsForm.valid) {
      this.dialogRef.close(this.paramsForm.getRawValue());
    }
  }

  closeDialog() {
    this.dialogRef.close()
  }
}
